import React, { useState } from "react"
import MeetingPaymentEdit from './components/MeetingPaymentEdit'
import MeetingPaymentView from './components/MeetingPaymentView'

const MeetingPayment = (props: any) => {
    const [editFlag, setEditFlag] = useState(false)
    const paymentdata = { ...props.allAPIdata.meetingrooms.payment, ...{ meetingroomsid: props.allAPIdata.meetingrooms.meetingroomsid, meetingroomslangid: props.allAPIdata.meetingrooms.meetingroomslangid } }
    const [paymentData, setPaymentData] = useState<any>(paymentdata)
    return (
        <div>
            {editFlag ? <MeetingPaymentEdit paymentData={paymentData} setPaymentData={setPaymentData} setOneNavDisabled={props.setOneNavDisabled} setEditFlag={setEditFlag} /> :
                <MeetingPaymentView paymentData={paymentData} setOneNavDisabled={props.setOneNavDisabled} setEditFlag={setEditFlag} />}
        </div>
    )
}

export default MeetingPayment